import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Header {
	constructor() {
		this.navbar = document.querySelector('.main-navbar');
		this.menuToggle = this.navbar.querySelector('.menu-toggle');
		this.mobileMenu = document.querySelector('.mobile-menu');
		this.backBtn = document.querySelector('.back');
		this.langSwitchers = [...this.navbar.querySelectorAll('.lang-switcher a')];

		this.eraLinks = [...this.navbar.querySelectorAll('.era-nav a')];
		this.mobileLinks = [...this.mobileMenu.querySelectorAll('.mobile-nav a')];
		this.allLinks = [...this.eraLinks, ...this.mobileLinks, ...this.langSwitchers];
		this.logoLinks = [...document.querySelectorAll('a.logo')];

		this.initMobileMenu();
		this.updateActiveLink();
	}

	// Controlla dall'URL quale link è attivo e aggiorna gli href
	updateActiveLink() {
		const path = window.location.pathname;
		const normalize = (url) => url.replace(/\/(index\.html)?$/, '').replace(/\.html$/, '');
		const normalizedPath = normalize(path);
		const langPrefix = path.match(/\/(it|en)\//)?.[1] || '';

		// Mappa bilaterale it↔en per tutte le pagine
		const langMap = {
			'/it/home': '/en/home',
			'/en/home': '/it/home',
			'/it/le-origini-pirelli': '/en/pirelli-origin',
			'/en/pirelli-origin': '/it/le-origini-pirelli',
			'/it/sfide-vittorie-pirelli': '/en/challenges-wins-pirelli',
			'/en/challenges-wins-pirelli': '/it/sfide-vittorie-pirelli',
			'/it/innovazione-sostenibilita-pirelli': '/en/innovation-sustainability-pirelli',
			'/en/innovation-sustainability-pirelli': '/it/innovazione-sostenibilita-pirelli',
			'/it/silverstone': '/en/silverstone',
			'/en/silverstone': '/it/silverstone',
		};

		// Logo: aggiorna href in base alla lingua corrente
		const logoUrls = {
			it: 'https://www.fondazionepirelli.org/it/',
			en: 'https://www.fondazionepirelli.org/en/',
		};
		if (langPrefix && logoUrls[langPrefix]) {
			this.logoLinks.forEach(logo => logo.setAttribute('href', logoUrls[langPrefix]));
		}

		// Mappa degli URL delle ere per lingua
		const eraUrls = {
			it: ['/it/le-origini-pirelli.html', '/it/sfide-vittorie-pirelli.html', '/it/innovazione-sostenibilita-pirelli.html'],
			en: ['/en/pirelli-origin.html', '/en/challenges-wins-pirelli.html', '/en/innovation-sustainability-pirelli.html']
		};

		// Aggiorna gli href dei link era nella lingua corretta
		if (langPrefix && eraUrls[langPrefix]) {
			const urls = eraUrls[langPrefix];
			[...this.eraLinks].forEach((link, i) => {
				if (urls[i]) link.setAttribute('href', urls[i]);
			});
			[...this.mobileLinks].forEach((link, i) => {
				if (urls[i]) link.setAttribute('href', urls[i]);
			});
		}

		// Era links: confronto path normalizzati per active state
		[...this.eraLinks, ...this.mobileLinks].forEach(link => {
			const href = link.getAttribute('href');
			const normalizedHref = normalize(href);
			if (normalizedHref && normalizedPath === normalizedHref) {
				link.classList.add('active');
			} else {
				link.classList.remove('active');
			}
		});

		// Lang switcher: aggiorna href e stato attivo
		const alternateUrl = langMap[normalizedPath] ? langMap[normalizedPath] + '.html' : null;

		this.langSwitchers.forEach(link => {
			const linkLang = link.textContent.trim().toLowerCase() === 'it' ? 'it' : 'en';

			if (linkLang === langPrefix) {
				// Lingua attiva: punta alla pagina corrente
				link.setAttribute('href', path);
				link.classList.add('active');
			} else {
				// Altra lingua: usa la URL mappata
				if (alternateUrl) {
					link.setAttribute('href', alternateUrl);
				}
				link.classList.remove('active');
			}
		});
	}

	// Scroll behavior: ScrollTrigger scrubba l'header dal basso al top, poi diventa sticky
	initScrollBehavior() {
		if (this.navbar.classList.contains('top')) return;

		const mm = gsap.matchMedia();

		mm.add('(min-width: 768px)', () => {
			const travel = window.innerHeight - 85;

			// L'header è fixed in basso. Scrubbiamo y da 0 a -travel per portarlo in cima.
			gsap.to(this.navbar,
				{
					force3D: true,
					scrollTrigger: {
						trigger: document.body,
						start: 'top top',
						end: `+=${travel}`,
						scrub: true,
						onLeave: () => {
							this.navbar.classList.add('is-fixed');
						},
						onEnterBack: () => {
							this.navbar.classList.remove('is-fixed');
						},
					}
				}
			);
		});
	}

	// Mobile menu toggle
	initMobileMenu() {
		if (!this.menuToggle || !this.mobileMenu) return;

		this.menuToggle.addEventListener('click', () => this.openMenu());

		if (this.backBtn) {
			this.backBtn.addEventListener('click', () => this.closeMenu());
		}

		// Chiudi menu al click su un link
		this.mobileLinks.forEach(link => {
			link.addEventListener('click', () => this.closeMenu());
		});
	}

	openMenu() {
		this.mobileMenu.classList.add('is-open');
		this.mobileMenu.setAttribute('aria-hidden', 'false');
		this.menuToggle.setAttribute('aria-expanded', 'true');
	}

	closeMenu() {
		this.mobileMenu.classList.remove('is-open');
		this.mobileMenu.setAttribute('aria-hidden', 'true');
		this.menuToggle.setAttribute('aria-expanded', 'false');
	}

	backToHome() {

		const dur = window.innerWidth > 768 ? 1 : 0.6;

		this.tl_back = gsap.timeline({
			defaults: {ease: "expo.out", force3D: true}
		});

		this.tl_back
			.to(this.navbar, {y: '-100%', duration: dur, opacity: 0}, 0)
			.set(this.navbar, {autoAlpha: 0}, ">")
			.add(() => {
				this.navbar.classList.remove('is-fixed', 'top');
				gsap.set(this.navbar, {y: '100%', autoAlpha: 1})
			}, ">0.4")

		return this.tl_back;
	}
}
